<template>
  <Teleport to="body">
    <div
      v-if="isOpen"
      class="pointer-events-none fixed inset-0 z-[140]"
      role="dialog"
    >
      <div
        v-if="!isMobile"
        class="absolute inset-0 flex items-end justify-start p-4"
      >
        <div class="pointer-events-auto relative w-[calc(100vw-2rem)] max-w-[304px] rounded-[18px] border border-orange1/14 bg-gradient-to-b from-dark2 to-dark1 shadow-[0_20px_60px_rgba(0,0,0,0.35),inset_0_-10px_28px_rgba(255,120,71,0.05)]">
          <button
            class="absolute right-3 top-3 flex size-8 items-center justify-center rounded-full text-purple-gray transition-colors hover:text-soft-gray cursor-pointer"
            type="button"
            aria-label="Close"
            @click="handleClose"
          >
            <X class="size-5" />
          </button>

          <div class="flex flex-col gap-4 p-4">
            <div class="flex items-center gap-3 pr-8">
              <div class="flex size-[46px] shrink-0 items-center justify-center rounded-[14px] border border-orange1/10 bg-orange1/10 text-orange2">
                <Flame class="size-6" />
              </div>

              <h2 class="text-left text-[18px] font-semibold leading-6 tracking-[-0.36px] text-orange2">
                {{ burnTitle }}
              </h2>
            </div>

            <p class="text-[14px] font-semibold leading-6 tracking-[-0.28px] text-purple-gray">
              {{ t('powerMilesBurnReminder.body') }}
            </p>

            <button
              class="inline-flex w-fit items-center gap-2 rounded-full border border-orange1/12 bg-dark3 px-4 py-2.5 text-[14px] font-semibold tracking-[-0.14px] text-orange2 shadow-[inset_0_1px_18px_rgba(255,120,71,0.12)] transition-colors hover:border-orange1/20 hover:text-amber-soft"
              type="button"
              @click="handleUsePowerMiles"
            >
              <InlineSvg
                :src="powerIcon"
                class="size-4.5 shrink-0"
                unique-ids
              />
              {{ t('powerMilesBurnReminder.cta') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
  <Teleport to="body">
    <div
      v-if="isOpen && isMobile"
      class="pointer-events-none fixed inset-0 z-[141] flex items-end justify-center p-4"
      role="dialog"
    >
      <div class="pointer-events-auto relative w-full max-w-[420px] rounded-[28px] border border-orange1/12 bg-gradient-to-b from-dark2 to-dark1 shadow-[0_20px_60px_rgba(0,0,0,0.35),inset_0_-10px_28px_rgba(255,120,71,0.05)]">
        <button
          class="absolute right-4 top-4 flex size-8 items-center justify-center rounded-full text-purple-gray transition-colors hover:text-soft-gray"
          type="button"
          aria-label="Close"
          @click="handleClose"
        >
          <X class="size-5" />
        </button>

        <div class="flex flex-col gap-4 p-5">
          <div class="flex items-center gap-4 pr-10">
            <div class="flex size-[52px] shrink-0 items-center justify-center rounded-[18px] border border-orange1/12 bg-orange1/10 text-orange2 shadow-[inset_0_1px_18px_rgba(255,120,71,0.10)]">
              <Flame class="size-7" />
            </div>

            <h2 class="text-left text-[24px] leading-7 font-semibold tracking-[-0.72px] text-orange2">
              {{ burnTitle }}
            </h2>
          </div>

          <p class="text-[15px] leading-6 tracking-[-0.3px] text-purple-gray">
            {{ t('powerMilesBurnReminder.body') }}
          </p>

          <button
            class="inline-flex w-fit items-center gap-2 rounded-full border border-orange1/12 bg-dark3 px-5 py-3 text-[15px] font-semibold tracking-[-0.15px] text-orange2 shadow-[inset_0_1px_18px_rgba(255,120,71,0.12)] transition-colors hover:border-orange1/20 hover:text-amber-soft"
            type="button"
            @click="handleUsePowerMiles"
          >
            <InlineSvg
              :src="powerIcon"
              class="size-5 shrink-0"
              unique-ids
            />
            {{ t('powerMilesBurnReminder.cta') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useMediaQuery } from '@vueuse/core'
import { useRouter } from 'vue-router'
import InlineSvg from 'vue-inline-svg'
import { Flame, X } from 'lucide-vue-next'
import powerIcon from '@/assets/images/game/power.svg'
import { usePowerMilesBurnReminder } from '@/composables/use-power-miles-burn-reminder'
import { useTranslation } from '@/composables/use-i18n'
import { LingoRouteName } from '@/router/routes'

const { t } = useTranslation()
const router = useRouter()
const isMobile = useMediaQuery('(max-width: 767px)')
const { burnTitle, shouldShowModal, dismissForToday } = usePowerMilesBurnReminder()

const isOpen = ref(false)

watch(shouldShowModal, (value) => {
  isOpen.value = value
}, { immediate: true })

const handleClose = () => {
  dismissForToday()
  isOpen.value = false
}

const handleUsePowerMiles = () => {
  dismissForToday()
  isOpen.value = false
  router.push({ name: LingoRouteName.REWARDS, query: { tab: 'raffle' } })
}
</script>
